import { createSelector } from 'reselect';
import { getI18n } from '../core/coreSelectors';
import { parseUsers } from 'src/redux/users/helpers/usersHelpers';
var usersState = function (state) { return state.users; };
export var getFilters = createSelector(usersState, function (state) { return state.collection.filters; });
export var getDisplayedColumns = createSelector(usersState, function (state) { return state.allColumns; });
export var getUsersCollection = createSelector(usersState, getFilters, getDisplayedColumns, getI18n, function (state, filters, columns, i18n) {
    if (filters) {
        return {
            collection: parseUsers(state.collection.results, columns, i18n),
            nbOfPages: Math.ceil(state.collection.total / filters.count),
            currentPages: filters.offset ? filters.offset / filters.count + 1 : 1,
            nbByPage: filters.count,
            total: state.collection.total,
        };
    }
    return {
        collection: [],
        nbOfPages: 0,
        nbByPage: 0,
        currentPages: 1,
        total: 0,
    };
});
export var getUsersCollectionLoading = createSelector(usersState, function (state) { return state.collection.isLoading; });
export var getCurrentUser = createSelector(usersState, function (state) {
    return state.current;
});
export var getImportUsersLoading = createSelector(usersState, function (state) { return state.import.isLoading; });
export var getImportUsersResults = createSelector(usersState, function (state) { return state.import.result; });
